import {RestResource} from '../rest'

import { ASSET_SERVER } from '../server'

const equipment = new RestResource({server: ASSET_SERVER, resource: 'asset'});

export default equipment;
